// get_sent_to_financier templates come back either as HTML (<div>/<br> from
// the web editor) or as plain text with \n — the mail modal edits plain text,
// so HTML is flattened to one line per block element.
const BLOCK_TAGS = /^(DIV|P|LI|H[1-6])$/;
export const templateToText = (tpl) => {
  const src = tpl || "";
  if (!/<[a-z][\s\S]*>/i.test(src)) return src;
  const body = new DOMParser().parseFromString(src, "text/html").body;
  let out = "";
  const walk = (node) =>
    node.childNodes.forEach((n) => {
      if (n.nodeType === 3) out += n.nodeValue;
      else if (n.nodeName === "BR") out += "\n";
      else {
        const block = BLOCK_TAGS.test(n.nodeName);
        if (block && out && !out.endsWith("\n")) out += "\n";
        walk(n);
        if (block && !out.endsWith("\n")) out += "\n";
      }
    });
  walk(body);
  return out.replace(/\n+$/, "");
};

// The mail modal edits plain text; sent_to_financier takes send_html_template.
const escapeHtml = (str) => str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
export const textToHtml = (text) => escapeHtml(text || "").replace(/\n/g, "<br>");
